<div class="content">
  <div class="viewer-google-map" #maps>
    <google-map appMapTheme [width]="'100%'" [height]="'100%'" [options]="mapOptions" id="google-map">
    </google-map>

    <div class="risk-markers" *ngIf="!capturing">
      <div class="image-marker" *ngFor="let vm of overlayImages" [style.left.px]="vm.x" [style.top.px]="vm.y"
        [class.expanded]="expandedImageId === vm.attachmentId">
        <img class="pastille" [src]="expandedImageId === vm.attachmentId ? vm.pastilleOrange : vm.pastilleRed"
          (click)="onPastilleClick(vm)" />

        <ng-container *ngIf="expandedImageId === vm.attachmentId">
          <img class="fan-icon" *ngFor="let r of vm.risks"
            [src]="r.metricId === currentRisk?.id ? r.iconOrange : r.iconRed"
            [style.transform]="'translate(calc(-50% + ' + r.dx + 'px), calc(-50% + ' + (r.dy - 22) + 'px))'"
            (click)="onFanClick(vm, r)" />
        </ng-container>
      </div>
    </div>
  </div>

  <div class="risk">
    <app-spinner *ngIf="loading" fill></app-spinner>

    <div *ngIf="!currentRisk && !loading">
      <h2>{{ "risks.no_risk" | translate }}</h2>
    </div>

    <app-risk-detail-panel *ngIf="currentImage && !loading" [image]="currentImage"
      [selectedNumber]="selectedNumber" [actionsByRisk]="actionsByRisk" (select)="onSelectNumber($event)"
      (showImage)="onShowImage()" (report)="reportRisk()" (linkAction)="linkAction()"
      (openAction)="openAction($event)" (commentEdit)="onCommentEdit()">
    </app-risk-detail-panel>
  </div>
</div>